import React from 'react';
import { Input } from '../../../../shared/ui/input';
import { Label } from '../../../../shared/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../shared/ui/select';
import { acceptNumericDraft } from '../../../../shared/utils/numericInput';
import '../../../../shared/components/party-form.css';
import '../../styles/accounting-form.css';

export function AccountingAmountField({ id, label = 'Importo', value, onChange, required = true, ...props }) {
  return <div className="party-form__field">
    <Label htmlFor={id}>{label}{required ? ' *' : ''}</Label>
    <div className="accounting-form__amount">
      <span aria-hidden="true">€</span>
      <Input id={id} type="text" inputMode="decimal" required={required} value={value ?? ''}
        placeholder="0,00" onChange={event => acceptNumericDraft(event, onChange, { min: 0.01 })} {...props} />
    </div>
  </div>;
}

export function AccountingSelectField({ id, label, value, onChange, options, required, disabled }) {
  return <div className="party-form__field">
    <Label htmlFor={id}>{label}{required ? ' *' : ''}</Label>
    <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} aria-required={required}><SelectValue placeholder="Seleziona..." /></SelectTrigger>
      <SelectContent>{options.map(option => <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>)}</SelectContent>
    </Select>
  </div>;
}
